import { useCallback } from 'react';
import FJRecentFiles from './FJRecentFiles';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { FJStartLandingAction } from '../../redux/action/FJStartLandingAction';
import { FJCommonAction } from '../../redux/action/FJCommonAction';
import useLocalStore from '../../hooks/useLocalStore';
import FJRequirementsUtil from '../../util/FJRequirementsUtil';

export default function FJRecentFilesContainer() {
    useLocalStore();
    const dispatch = useAppDispatch();
    const items = useAppSelector(state => state.startLanding.projects.items);
    const selectedProjectIds = useAppSelector(state => state.startLanding.projects.selectedProjectIds);
    const listTotalCount = useAppSelector(state => state.startLanding.projects.listTotalCount);
    const listHasMore = useAppSelector(state => state.startLanding.projects.listHasMore);
    const listLoadingMore = useAppSelector(state => state.startLanding.projects.listLoadingMore);

    const handleLoadMore = useCallback(() => {
        return dispatch(FJCommonAction.loadMoreTaskListAction());
    }, [dispatch]);

    const handleTryAgain = useCallback(
        (id: string) => {
            dispatch(FJStartLandingAction.tryAgainProjectAction(id));
        },
        [dispatch],
    );

    const handleRename = useCallback(
        (id: string) => {
            const row = items.find(i => i.id === id);
            FJRequirementsUtil.eaLog('recent_file_rename_click', {
                eventId: row?.eventId ?? '',
                title_content: row?.title ?? '',
            });
            dispatch(FJStartLandingAction.requestRenameProjectAction(id));
        },
        [dispatch, items],
    );

    const handleDelete = useCallback(
        (id: string) => {
            const row = items.find(i => i.id === id);
            FJRequirementsUtil.eaLog('recent_file_delete_click', { eventId: row?.eventId ?? '' });
            dispatch(FJStartLandingAction.removeProjectAction(id));
        },
        [dispatch, items],
    );

    const handleCardClick = useCallback(
        (id: string) => {
            dispatch(FJStartLandingAction.clickProjectThumbAction(id));
        },
        [dispatch],
    );

    const handleContinue = useCallback(
        (id: string) => {
            dispatch(FJStartLandingAction.resumePendingAction(id));
        },
        [dispatch],
    );

    const handleSetProjectSelection = useCallback(
        (ids: Array<string | number>) => {
            dispatch(FJStartLandingAction.setProjectSelectionAction(ids.map(String)));
        },
        [dispatch],
    );

    const handleToggleProjectSelection = useCallback(
        (id: string) => {
            dispatch(FJStartLandingAction.toggleProjectSelectionAction(id));
        },
        [dispatch],
    );

    const handleMultiDelete = useCallback(
        (ids: Array<string | number>) => {
            dispatch(FJStartLandingAction.requestMultiRemoveProjectsAction(ids.map(String)));
        },
        [dispatch],
    );

    const handleClearProjectSelection = useCallback(() => {
        dispatch(FJStartLandingAction.clearProjectSelectionAction());
    }, [dispatch]);

    return (
        <FJRecentFiles
            items={items}
            selectedProjectIds={selectedProjectIds}
            listTotalCount={listTotalCount}
            listHasMore={listHasMore}
            listLoadingMore={listLoadingMore}
            onLoadMore={handleLoadMore}
            onTryAgain={handleTryAgain}
            onRename={handleRename}
            onDelete={handleDelete}
            onCardClick={handleCardClick}
            onContinue={handleContinue}
            onSetProjectSelection={handleSetProjectSelection}
            onToggleProjectSelection={handleToggleProjectSelection}
            onRangeProjectSelection={handleSetProjectSelection}
            onMultiDelete={handleMultiDelete}
            onClearProjectSelection={handleClearProjectSelection}
        />
    );
}
